import React from 'react';
import type { ComponentType } from 'react';
import type { MessageDescriptor } from 'react-intl-next';
import { FormattedMessage } from 'react-intl-next';
import { styled } from '@compiled/react';

import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import type { NewCoreIconProps } from '@atlaskit/icon/types';
import { token } from '@atlaskit/tokens';
import { Box } from '@atlaskit/primitives/compiled';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	width: 420,
	display: 'flex',
	marginTop: token('space.150'),
	marginBottom: token('space.150'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CoreCheckIconWrapper = styled.div({
	marginTop: token('space.025'),
	paddingTop: token('space.100'),
	paddingRight: token('space.150'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CoreIconBackground = styled.div({
	backgroundColor: token('color.background.information'),
	height: 36,
	width: 36,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	borderRadius: token('radius.medium'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ContentWrapper = styled.div({
	width: 364,
	flexDirection: 'column',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TextAreaTitle = styled.div({
	font: token('font.body'),
	fontWeight: token('font.weight.bold'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TextAreaBody = styled.div({
	font: token('font.body'),
});

export enum CheckIconStatus {
	CHECKED,
	UNCHECKED,
	NOT_RENDERED,
}

export type ListItemProps = {
	bodyText: MessageDescriptor;
	icon: ComponentType<NewCoreIconProps>;
	title: MessageDescriptor;
	checkIconStatus?: CheckIconStatus;
};

export const ListItem = ({
	icon,
	title,
	bodyText,
	checkIconStatus = CheckIconStatus.NOT_RENDERED,
}: ListItemProps) => {
	const Icon = icon;

	return (
		<Wrapper>
			{checkIconStatus === CheckIconStatus.UNCHECKED && (
				<CoreCheckIconWrapper>
					<CheckCircleIcon
						label=""
						testId="unchecked-icon"
						spacing="spacious"
						color={token('color.icon')}
					/>
				</CoreCheckIconWrapper>
			)}
			{checkIconStatus === CheckIconStatus.CHECKED && (
				<CoreCheckIconWrapper>
					<CheckCircleIcon
						label=""
						testId="checked-icon"
						spacing="spacious"
						color={token('color.icon.success')}
					/>
				</CoreCheckIconWrapper>
			)}
			<Box paddingBlockStart="space.050" paddingInlineEnd="space.200">
				<CoreIconBackground>
					<Icon label="" color={token('color.icon.information')} />
				</CoreIconBackground>
			</Box>
			<ContentWrapper>
				<TextAreaTitle>
					<FormattedMessage {...title} />
				</TextAreaTitle>
				<TextAreaBody>
					<FormattedMessage {...bodyText} />
				</TextAreaBody>
			</ContentWrapper>
		</Wrapper>
	);
};
